import { render, staticRenderFns } from "./ChainTableEdit.vue?vue&type=template&id=010237e6"
import script from "./ChainTableEdit.vue?vue&type=script&lang=js"
export * from "./ChainTableEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports